import React, { Component } from 'react';
import Search from '../Search/';
import Scan from '../Scan/';
import styles from './styles.scss';
import request from '../../request';
import * as print from 'print';
import * as Helper from '../../utils/helper';
import { captureEvent } from '../../utils/sentryHelper';

export default class PrintAsn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 'search',
            data: {},
        };
    }

    printLabel = items => {
        const labels = items.map(product => {
            const qty = product.qty || 1;
            const label = `${product.title_en}`.trim();
            const data = { ...product, qty, label };
            return print.generateLabel(data);
        });

        print.print(labels);
    };

    async componentDidMount() {
        const idAsn = this.props.match.params.idAsn;
        request
            .get(`/_svc/inbound-po-api/asn/${idAsn}/lines`)
            .then(response => this.setState({ data: response }))
            .catch(error =>
                captureEvent((error && error.message) || error, {
                    logger: 'PrintAsn.componentDidMount',
                    extra: error,
                    level: Helper.getSentryErrorLevel(error.code),
                }),
            );
    }

    render() {
        const { data, view } = this.state;
        const idPartner = data.asn ? data.asn.from_partner : 0;
        const domain = window.location.hostname
            .split('.')
            .slice(-2)
            .join('.');
        const idAsn = this.props.match.params.idAsn;
        return (
            <div className={styles.homeScreen}>
                <div className={styles.viewSwitcher}>
                    <button
                        className={
                            this.state.view === 'search' ? styles.active : {}
                        }
                        onClick={() => this.setState({ view: 'search' })}
                    >
                        <i className="icon-search" />
                        Search
                    </button>
                    <button
                        className={
                            this.state.view === 'scan' ? styles.active : {}
                        }
                        onClick={() => this.setState({ view: 'scan' })}
                    >
                        <i className="icon-barcode" />
                        Scan
                    </button>
                    <button>
                        <a href={`https://inbound-po.${domain}/asn/${idAsn}`}>
                            ASN
                        </a>
                    </button>
                </div>
                {view === 'search' ? (
                    <Search printLabel={this.printLabel} data={data} />
                ):(
                    <Scan printLabel={this.printLabel} data={data} />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrintAsn/index.js